<div class="app-breadcrumb">
    <span *ngFor="let i of breadcrumbList" (click)="handleNavigate(i.url)" class="app-breadcrumb__item">
        {{ i.key | translate }}
    </span>
</div>